import React from "react";
import NotificationToggleButtonListItem from "./NotificationToggleButtonListItem.component";

const NotificationSettings = () => {
  return (
    <div className="flex-col h-fit w-full  radius-10 back-white  align-left justify-start  pt-3 pb-2 pl-3 pr-3 g-2">
      <div className="w-full flex-col align-left justify-start g-1">
        <h3 className="t-16 color-grayColor poppins-medium weight-500">
          Notification
        </h3>
        <hr color="#e5e5e5" className="w-full" />
      </div>

      <div className="w-full flex-col align-left justify-start g-1">
        <NotificationToggleButtonListItem title={"Mute notification"} />
        <NotificationToggleButtonListItem
          title={"Sub admin get notification access"}
        />
        <NotificationToggleButtonListItem
          title={"Act admin get notification access as admin"}
        />
        <NotificationToggleButtonListItem
          title={"Disable notification from side bar"}
        />
      </div>
    </div>
  );
};

export default NotificationSettings;
